var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 22,
    height: 22,
    transform: "translate(487 75)",
    fill: "#c06c84",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(-487 -75)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back-2",
    "data-name": "back",
    transform: "translate(487 75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subdirectory_Arrow_Left",
    d: "M9.72,5.776a.911.911,0,0,0-1.3,0l-7.217,7.3a.945.945,0,0,0-.024,1.332l7.241,7.322a.911.911,0,0,0,1.3,0,.93.93,0,0,0,0-1.308L4.032,14.669H20.163a.917.917,0,0,0,.917-.917V.917a.917.917,0,1,0-1.833,0v11.9H4.047L9.72,7.085A.931.931,0,0,0,9.72,5.776Z",
    fill: "#c06c84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2e076ff58360faff25ffe42768f91fdd.svg";
export { ForwardRef as ReactComponent };